import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import './Signin.css';
import { UserAuth } from '../../context/AuthContext';

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { user, loading, signIn } = UserAuth();

  if (loading) {
    return null;
  }

  if (user) {
    return <Navigate to="/userarea" />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      await signIn(email, password);
      navigate('/userarea');
    } catch (err) {
      setError('Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.');
      setSubmitting(false);
    }
  };

  return (
    <div className="signin-section">
      <form className="signin-form" onSubmit={handleSubmit}>
        <span className="label-sub">Team-Bereich</span>
        <h1>Anmelden</h1>
        {error && <p className="signin-error">{error}</p>}
        <label className="signin-field">
          <span>E-Mail</span>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
        </label>
        <label className="signin-field">
          <span>Passwort</span>
          <input
            type="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>
        <button type="submit" className="signin-submit" disabled={submitting}>
          {submitting ? 'Anmelden…' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
